// client/src/components/pages/TelegramBI/BotManager/botCommands.ts
//
// The commands the Telegram bot answers (server/services/telegram/botService handleCommand and
// its /help text). DAQ-11 / ST-00203: the Bot Manager used to advertise /delayed, /route and
// /compare, which the bot answers with "Unknown command", and showed arguments for /subscribe and
// /unsubscribe, which take none (they reply with buttons). Keep this list in step with the bot:
// a command added to or removed from the bot's switch must be added or removed here too.

import type { BotCommandInfo } from '../../../../types/telegramBotManager';

export const BOT_COMMANDS: readonly BotCommandInfo[] = Object.freeze([
  {
    command: '/today',
    description: "Today's operations summary: tickets, tonnage, hauliers and vehicles",
    example: '/today',
  },
  {
    command: '/yesterday',
    description: "Yesterday's operations summary",
    example: '/yesterday',
  },
  {
    command: '/mtd',
    description: 'Month-to-date tonnage and ticket overview',
    example: '/mtd',
  },
  {
    command: '/volume',
    description: 'Daily volume trend for the last 7 days',
    example: '/volume',
  },
  {
    command: '/alerts',
    description: 'Route intelligence alerts from the last 7 days',
    example: '/alerts',
  },
  {
    command: '/search',
    description: 'Search tickets by ticket number, delivery number or vehicle registration',
    example: '/search 12345',
  },
  {
    command: '/queries',
    description: 'List the saved queries this chat can run',
    example: '/queries',
    aliases: ['/list'],
  },
  {
    command: '/execute',
    description: 'Run a saved query by its ID, optionally with key=value parameters',
    example: '/execute 2 date=2026-10-01',
  },
  {
    command: '/templates',
    description: 'List the available report templates',
    example: '/templates',
  },
  {
    command: '/schedules',
    description: 'List your scheduled reports',
    example: '/schedules',
  },
  {
    command: '/subscribe',
    description: 'Show the scheduled reports you can subscribe to (pick one from the buttons)',
    example: '/subscribe',
  },
  {
    command: '/unsubscribe',
    description: 'Show your subscriptions with a button to unsubscribe from each',
    example: '/unsubscribe',
  },
  {
    command: '/mute',
    description:
      'Mute notifications for a while (m = minutes, h = hours, d = days; at most 30 days)',
    example: '/mute 2h',
  },
  {
    command: '/status',
    description: 'System status and statistics',
    example: '/status',
  },
  {
    command: '/settings',
    description: 'Show your bot settings',
    example: '/settings',
  },
  {
    command: '/cancel',
    description: 'Cancel the current operation',
    example: '/cancel',
  },
  {
    command: '/start',
    description: 'Welcome message and whether this chat is authorized',
    example: '/start',
  },
  {
    command: '/help',
    description: 'Show available commands and usage instructions',
    example: '/help',
  },
]);
